/**
 * Tabs for TabsBlock.
 *
 * The server renders every panel visible and the tab row hidden, which is the
 * only state that works without this script: all four plans readable, and no
 * row of buttons that cannot do anything. Turning that into a tab set is this
 * file's job, and it happens in one step at init — reveal the row, hide every
 * panel but the active one — so a visitor never sees the stacked state flash
 * before it collapses.
 *
 * After that it only maintains the state: the .active class, aria-selected, the
 * roving tabindex, and the [hidden] on each panel.
 *
 * Roving tabindex is the standard tablist pattern — the selected tab is the
 * only one in the tab order, and the arrow keys move between them.
 */
(function() {
    'use strict';

    function initTabs(root) {
        var tabs = root.querySelectorAll('[data-tab]');
        var panels = root.querySelectorAll('[data-tab-panel]');
        var list = root.querySelector('[role="tablist"]');

        if (tabs.length === 0) return;

        // The row is inert until now, so the server ships it hidden. Reveal it
        // before collapsing the panels, so the controls exist by the time the
        // content they control goes away.
        if (list) {
            list.hidden = false;
            list.removeAttribute('aria-hidden');
        }

        function select(index, moveFocus) {
            tabs.forEach(function(tab, i) {
                var isActive = i === index;
                tab.classList.toggle('active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            panels.forEach(function(panel, i) {
                panel.hidden = i !== index;
            });

            if (moveFocus && tabs[index]) {
                tabs[index].focus();
            }
        }

        // Collapse the stack onto whichever tab the server marked active,
        // falling back to the first.
        var initial = 0;
        tabs.forEach(function(tab, i) {
            if (tab.classList.contains('active')) initial = i;
        });
        select(initial, false);

        tabs.forEach(function(tab, i) {
            tab.addEventListener('click', function() {
                select(i, false);
            });

            tab.addEventListener('keydown', function(e) {
                var last = tabs.length - 1;
                var next = null;

                if (e.key === 'ArrowRight') {
                    next = i === last ? 0 : i + 1;
                } else if (e.key === 'ArrowLeft') {
                    next = i === 0 ? last : i - 1;
                } else if (e.key === 'Home') {
                    next = 0;
                } else if (e.key === 'End') {
                    next = last;
                }

                if (next !== null) {
                    e.preventDefault();
                    select(next, true);
                }
            });
        });
    }

    function initAllTabs() {
        document.querySelectorAll('[data-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllTabs);
    } else {
        initAllTabs();
    }
})();
